import Vue from 'vue'
import {clone} from 'ramda'

Vue.filter('clone', function(value) {
  return clone(value)
})
